import { CLEAR_AVAILABILITY_LIST, SET_AVAILABILITY_PAGE_ERROR } from './AvailabilityConstants'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function setAvailabilityPageError(newStatus) {
  return {
    type: SET_AVAILABILITY_PAGE_ERROR,
    payload: newStatus,
  }
}
export function clearAvailabilitiesList() {
  return {
    type: CLEAR_AVAILABILITY_LIST,
  }
}
